/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'chatbot/report': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path d="M9 14C9.28333 14 9.52083 13.9042 9.7125 13.7125C9.90417 13.5208 10 13.2833 10 13C10 12.7167 9.90417 12.4792 9.7125 12.2875C9.52083 12.0958 9.28333 12 9 12C8.71667 12 8.47917 12.0958 8.2875 12.2875C8.09583 12.4792 8 12.7167 8 13C8 13.2833 8.09583 13.5208 8.2875 13.7125C8.47917 13.9042 8.71667 14 9 14ZM8 10H10V4H8V10ZM5.25 18L0 12.75V5.25L5.25 0H12.75L18 5.25V12.75L12.75 18H5.25ZM6.1 16H11.9L16 11.9V6.1L11.9 2H6.1L2 6.1V11.9L6.1 16Z" fill="white"/>'
  }
})

